// app._index.tsx — the embedded home/dashboard screen.
export const dashboard = {
  trialBanner: {
    prefix: "Your free trial ends in",
    dayUnit: "day",
    daysUnit: "days",
    pickPlanLink: "Pick a plan",
    suffix: "to keep your quotes active.",
  },
  atAGlance: {
    heading: "At a glance",
    openQuotes: "Open quotes",
    pendingPoImports: "Pending PO imports",
    plan: "Plan",
    trialEnds: "Trial ends {{date}}",
  },
  nextBestAction: {
    heading: "Next best action",
    emptyBefore:
      "AI suggestions land here as you work. Quote Desk prices quote lines and drafts counter-offers from each company's own order history — open a draft quote and try “Suggest prices with AI”. Teach the AI your pricing rules and voice once in",
    emptyAfter: ".",
    priceSuggestion: "Price suggestion",
    review: "Review",
    unknownCompany: "(unknown company)",
  },
  followUp: {
    heading: "Needs follow-up",
    empty:
      "Nothing needs a nudge right now — nice work staying on top of it. Quotes that sit unviewed for 3+ days (or viewed without a decision for 5+) surface here so no deal goes quiet.",
    unviewedSent: "Sent > 3 days, buyer hasn't opened ({{count}})",
    viewedNotActedOn: "Viewed > 5 days, no accept/decline ({{count}})",
    daysIdle: "{{days}}d idle",
    daysSinceView: "{{days}}d since view",
  },
  performance: {
    heading: "Performance",
    empty:
      "Conversion rate, average time-to-accept, and your top companies light up here after your third quote — you're on your way!",
    totalQuotes: "Total quotes",
    conversion: "Conversion (accepted ÷ terminal)",
    avgTimeToAccept: "Avg time to accept",
    totalAcceptedValue: "Total accepted value",
    topCompanies: "Top companies by quote count",
    quoteCountOne: "{{count}} quote",
    quoteCountOther: "{{count}} quotes",
    accepted: "{{count}} accepted",
    won: "{{amount}} won",
  },
  recentQuotes: {
    heading: "Recent quotes",
    emptyHeading: "No quotes yet",
    emptyAction: "Create your first quote",
    emptyBody:
      "Build a B2B quote with custom pricing — your buyer accepts from a secure link and it becomes a Shopify draft order automatically.",
  },
  getStarted: {
    heading: "Get started",
    createQuote: "Create a quote",
    viewCompanies: "View companies",
    uploadPo: "Upload a PO",
    setUpAi: "Set up your AI",
    plansAndBilling: "Plans & billing",
  },
};
